module.exports = __webpack_public_path__ + "static/google-e4b94cccaad5270e0946bca73bb9c026.svg";